import { ReactNode } from 'react'
import { config } from '../config'

interface MigrationLayoutProps {
  children: ReactNode
}

export function MigrationLayout({ children }: MigrationLayoutProps) {
  return (
    <div className="layout">
      <header className="header">
        <nav className="nav">
          <div className="nav-brand">
            <div className="brand-link">
              <h2>SWGRealms</h2>
              <span className="brand-subtitle">Account Migration</span>
            </div>
          </div>
          
          <div className="nav-links">
            {/* Empty for migration pages */}
          </div>

          <div className="nav-auth">
            <a 
              href={config.homeUrl}
              className="btn btn-secondary"
              style={{ 
                fontSize: '0.8rem', 
                padding: '4px 8px', 
                textDecoration: 'none',
                color: '#00d4ff',
                borderColor: 'rgba(0, 212, 255, 0.3)'
              }}
            >
              Back to Main Site
            </a>
          </div>
        </nav>
      </header>

      <main className="main">
        {children}
      </main>

      <footer className="footer">
        <p>&copy; 2025 SWGRealms. All rights reserved.</p>
        <p style={{ marginTop: '8px', fontSize: '0.9rem' }}>
          Having trouble? Email <a href="mailto:support@swgrealms.com" style={{ color: '#00d4ff' }}>support@swgrealms.com</a>
        </p>
      </footer>
    </div>
  )
}
